import React, { useEffect, useState } from "react";
import Header from "../../../../Components/Header";
import DynamicTable from "../../../../Components/Table";
import CommonModal from "../../../../Components/Modals/index";
import { BASE_DOMAIN, columns, rows } from "../../../../utils/constants";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import {
  useDeleteCompanyMutation,
  useFetchcompanyQuery,
  useToggleCompanyMutation,
  useUpdateEmailMutation,
} from "../../../../features/Group/groupSlice";
import { DeleteOutlineOutlinedIcon, EditOutlinedIcon, ToggleOffOutlinedIcon, ToggleOnIcon } from "../../../../utils/icons";
import { useToast } from "../../../ToastProvider";

const GroupTable = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [newEmail, setNewEmail] = useState("");
  const [oldEmail, setOldEmail] = useState("");
  const [modalData, setModalData] = useState({
    title: "",
    description: "",
    icon: "",
    changeEmail: "",
  });
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const group = queryParams.get("grp");
  const grpname = queryParams.get("grpname");
  const [dropdown, setDropdown] = useState([]);
  const [filters, setFilters] = useState({}); // Example filter
  // const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [row, setRow] = useState({});
  // const [limit, setLimit] = useState(10);
  const [modal, setModal] = useState(false);
  const dynamicUrl = `${BASE_DOMAIN}companies/${id}`; // Replace with your actual URL
  const {
    data = { data: [] },
    error,
    isLoading,
    refetch,
  } = useFetchcompanyQuery({
    url: dynamicUrl,
    filters: { ...filters },
  });
  const [deleteCompany, { isLoading: delLoading, isSuccess, error: anyError }] = useDeleteCompanyMutation();
  const [toggleCompany, { isLoading: toggleLoading, isSuccess: togSuccess, isError }] = useToggleCompanyMutation();
  const [updateEmail, { isLoading: emailUpdateLoading }] = useUpdateEmailMutation();
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  useEffect(() => {
    console.log("Filters updated:", filters);
    refetch();
  }, [location.pathname, filters]);

  const handlePageChange = (page) => {
    setFilters({
      ...filters,
      page: page,
    });
    setCurrentPage(page);
  };

  // console.log("DATA", data, isLoading, queryParams.get("grp"), queryParams.get("grpname"), filters);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setFilters({ ...filters, search: value });
  };

  const handleRowValue = (val) => {
    setRow(val);
    if (val.status === "Inactive") {
      setDropdown([
        {
          name: "Edit Company",
          icon: <EditOutlinedIcon />,
          id: 1,
        },
        {
          name: "Delete Company",
          icon: <DeleteOutlineOutlinedIcon />,
          id: 2,
        },
        {
          name: "Make Company Active",
          icon: <ToggleOffOutlinedIcon />,
          id: 3,
        },
        {
          name: "Change Email",
          icon: <EditOutlinedIcon />,
          id: 4,
        },
      ]);
    } else {
      setDropdown([
        {
          name: "Edit Company",
          icon: <EditOutlinedIcon />,
          id: 1,
        },
        {
          name: "Delete Company",
          icon: <DeleteOutlineOutlinedIcon />,
          id: 2,
        },
        {
          name: "Make Company Inactive",
          icon: <ToggleOffOutlinedIcon />,
          id: 3,
        },
        {
          name: "Change Email",
          icon: <EditOutlinedIcon />,
          id: 4,
        },
      ]);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("vv", parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
    const newLimit = parseInt(event.target.value, 10);
    setFilters((prevFilters) => ({
      ...prevFilters,
      limit: newLimit,
      page: 1, // Reset to the first page whenever rows per page changes
    }));
    setCurrentPage(1); // Reset to the first page whenever rows per page changes
  };

  const handleMenuItem = (val) => {
    if (val.id === 1) {
      navigate({
        pathname: "/super/group/add-user",
        search: `?${createSearchParams({ id: id, isupdate: true, compid: row.id, grp: group, grpname: grpname })}`,
      });
    }
    if (val.id === 2) {
      setModalData({
        title: "Delete Company",
        description: "Are you sure you want to delete this company?",
        icon: true,
      });

      setModal(true);
    }
    if (val.id === 3) {
      console.log(row, "rowwwwww");

      setModalData({
        title: row.status === "Inactive" ? "Make Company Active" : "Make Company Inactive",
        description: row.status === "Inactive" ? "Are you sure you want to make Company active?" : "Are you sure you want to make Company inactive?",
        icon: false,
      });

      setModal(true);
    }
    if (val.id === 4) {
      setModalData({
        title: "Change Email",
        // description: "Input Fields",
        changeEmail: true,
        icon: false,
      });

      setModal(true);
    }
  };

  const handleReset = () => {
    setFilters({
      page: 1,
      limit: 10,
    });
  };

  const handleFilter = (itm1 = [], itm2 = []) => {
    function replaceGasAndElectricIfPresent(inputArray) {
      console.log("INP", inputArray);
      if (inputArray.includes("Gas & electric")) {
        return inputArray.map((item) => (item === "Gas & electric" ? "GasandElectric" : item));
      }
      return inputArray;
    }

    const updatedEnergyTypes = replaceGasAndElectricIfPresent(itm2);
    console.log(updatedEnergyTypes, "UPD");

    if (itm1.length > 0 && updatedEnergyTypes.length > 0) {
      setFilters({
        ...filters,
        category: itm1,
        utilityType: updatedEnergyTypes,
      });
    } else if (itm1.length > 0) {
      setFilters({
        ...filters,
        category: itm1,
      });
    } else if (updatedEnergyTypes.length > 0) {
      setFilters({
        ...filters,
        utilityType: updatedEnergyTypes,
      });
    } else {
      setFilters({
        page: 1,
      });
    }
  };

  const handleConfirmAction = async (data) => {
    let oldEmailSelected = data?.email;
    try {
      if (modalData.title === "Delete Company") {
        const result = await deleteCompany(row.id).unwrap();
        refetch();
      } else if (modalData.title === "Change Email") {
        if (newEmail && oldEmailSelected) {
          try {
            let getRest = await updateEmail({
              id: row.companyId,
              body: {
                NewEmail: newEmail,
                OldEmail: oldEmailSelected,
              },
            }).unwrap();
            setNewEmail("");
            setOldEmail("");
            showSuccess({
              body: "Email updated successfully",
            });
            refetch();
          } catch (err) {
            showError({
              body: err?.data?.message || err?.status || "something went wrong",
            });
          }
        }
      } else {
        const result = await toggleCompany(row.id).unwrap();
        refetch();
      }
    } catch (err) {}

    setModal(false);
  };

  const handleAction1Click = () => {
    navigate({
      pathname: "/super/group/add-user",
      search: `?${createSearchParams({ id: id, grp: group, grpname: grpname })}`,
    });
    // navigate("/super/group/add-user")
  };

  const handleBack = () => {
    navigate("/super/group");
  };

  const handleSort = () => {
    setFilters({
      ...filters,
    });
  };
  return (
    <div>
      <Header
        title={queryParams.get("grpname") || "Group List"}
        description={`#${queryParams.get("grp")}` || "#ID0000"}
        searchValue={searchValue}
        isSearchDisable={false}
        btnText='Add Company'
        searchText='Search by Company name'
        isIcon={true}
        isFilter={true}
        isback={true}
        onFilterClick={handleFilter}
        onReset={handleReset}
        onSearchChange={handleSearchChange}
        onAction1Click={handleAction1Click}
        handleBack={handleBack}
      />
      <DynamicTable
        columns={columns}
        rows={data?.data}
        isLoading={isLoading}
        onClick={handleSort}
        total={Math.ceil(data?.total / 10)}
        dropMenuList={dropdown}
        currentPage={currentPage}
        handleAction={handleRowValue}
        handleMenu={handleMenuItem}
        // page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {modal && (
        <CommonModal
          setIsOpenPopUp={setModal}
          open={modal}
          isLoading={delLoading || toggleLoading}
          handleDelete={() => handleConfirmAction(row)}
          item={{
            title: modalData.title,
            description: modalData.description,
            icon: modalData.icon,
            changeEmail: modalData.changeEmail,
          }}
          setNewEmail={setNewEmail} // Pass this function
        />
      )}
    </div>
  );
};

export default GroupTable;
